module.exports = __webpack_public_path__ + "static/media/eye.e01260dd.svg";